import { FlexColumn } from '@gorila-shared-ui/components';
import { LabelSmall, ParagraphXSmall } from 'baseui/typography';
import { useStyles } from '../../hooks/useStyles';

type Props = Readonly<{
  label: string;
  content: string;
}>;

function DataDescription({ content, label }: Props) {
  const { theme } = useStyles();

  return (
    <FlexColumn gap={0}>
      <LabelSmall>{label}</LabelSmall>
      <ParagraphXSmall
        margin={0}
        color={theme.colors.contentSecondary}
      >
        {content}
      </ParagraphXSmall>
    </FlexColumn>
  );
}

export default DataDescription;
